export function getCollaborationAppFileLink(fileName: string, token: string) {
    const file = fileName.split("."),
        extension = file.pop()?.toLowerCase(),
        name = file[0];

    return (
        import.meta.env.VITE_API_URL +
        "/api/v1/tool/download-output-file/" +
        name +
        "/" +
        extension +
        "?access_token=" +
        token
    );
}
